import type { Dependencies } from "@redux/store";
import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import type { ExternalProviderBatchRequestVM } from "@shared-kernel/application/ports/admin/admin-repository";

export const adminRetrieveExternalProviderBatchRequest = createAsyncThunk<
  ExternalProviderBatchRequestVM,
  string,
  { extra: Partial<Dependencies> }
>("externalProviderBatchRequests/adminRetrieveExternalProviderBatchRequest", async (requestId, { extra: { adminRepository } }) => {
  return adminRepository!.getExternalProviderBatchRequest(requestId);
});

export const resetAdminRetrieveExternalProviderBatchRequest = createAction(
  "externalProviderBatchRequests/resetAdminRetrieveExternalProviderBatchRequest",
);
